<div class="layout-column layout-align-center-center full-height"
     [ngClass]="[status, (small ? 'small' : '')]"
     [ngbTooltip]="status | translate"
     openDelay="300">

  <span *ngIf="small; else regular">
    {{'STATUS_TAG.' + status | translate}}
  </span>

  <ng-template #regular>
    {{status | translate}}
  </ng-template>


</div>
